import { fork } from 'redux-saga/effects'

import * as breadcrumb from 'sagas/breadcrumb'
import * as user from 'sagas/user'

export default function* main() {
  yield fork(breadcrumb.main)
  yield fork(user.main)
}
